import React, { useState } from 'react'
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import 'react-phone-input-2/lib/style.css';
import SignUp from '../SignUp';
import { Translate } from '../../localization';

function CustomModal({ openModal }) {
    const [showModal, setShowModal] = useState(openModal)
    const [showSignUpModal, setShowSignUpModal] = useState(false)
    const handleSignUp = () => {
        setShowSignUpModal(true)
    }
    const hideSignUpModal = () => {
        setShowSignUpModal(false)
    }
    const handleHideModal = () => {
        setShowModal(false)
    }
    return (
        <React.Fragment>
            <Dialog onClose={handleHideModal} aria-labelledby="login-dialog-title" open={showModal} className="auth__modal login-modal" scroll="body">
                <DialogTitle id="" className="notice-header" disableTypography>
                    <div className="notice-text">{Translate.notice}</div>
                    <IconButton aria-label="close" className="close-modal" onClick={handleHideModal}>
                        <i className="material-icons text-white fs-22"> close </i>
                    </IconButton>
                </DialogTitle>
                <DialogContent className="pt-0 model-text">
                    <div className='offer-text'>
                        
                        <p className="popup-heading">{Translate.customMsg} <span>{Translate.customPrice}</span></p>
                        <p className="popup-heading-span"><span>{Translate.subCustomMsg}</span></p>
                    </div>
                    <div className='signup-btn'>
                        <Button
                            variant="contained"
                            className="btn d-flex justify-content-center btn-login my-2 signup-button"
                            onClick={handleSignUp}
                        >
                          {Translate.signup}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
            {showSignUpModal && <SignUp hideSignUp={hideSignUpModal} />}
        </React.Fragment>
    )
}

export default CustomModal